var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.label ? 'label' : 'button',{tag:"component",class:{
    'btn btn-fancy': true,
    'btn-loading': _vm.isLoading,
    disabled: _vm.disabled,
  },attrs:{"disabled":_vm.disabled,"tabindex":_vm.isLoading ? '-1' : null},on:{"click":function($event){$event.stopPropagation();return _vm.click.apply(null, arguments)}}},[_c('span',[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]})],2),_c('IconSpinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }